import {AiSuggest} from "./AiSuggest";

export class AdminInit {
    constructor() {
        this.initSelect2();
        this.initWysiwyg();
    }

    initSelect2() {
        $('select.select2').select2();
    }

    initWysiwyg() {
        const token = $('meta[name=csrf-token]').attr('content');
        new AiSuggest();

        $('.redactor').each(function() {
            if ($(this).data('redactorimageupload') !== undefined) {
                $(this).redactor({
                    imageUpload: $(this).data('redactorimageupload') + '?_token=' + token,
                    imageManagerJson: $(this).data('redactorimagemanagerjson'),
                    fileUpload: $(this).data('redactorfileupload') + '?_token=' + token,
                    fileManagerJson: $(this).data('redactorfilemanagerjson'),
                    imageResizable: true,
                    imagePosition: true,
                    plugins: ['imagemanager', 'filemanager', 'alignment', 'inlinestyle', 'table', 'fontsize', 'fontcolor', 'fontfamily', 'fullscreen', 'mygrids', 'source', 'openaisuggest'],
                });
            } else {
                $(this).redactor({
                    plugins: ['alignment', 'inlinestyle', 'table', 'fontsize', 'fontcolor', 'fontfamily', 'fullscreen', 'mygrids', 'source', 'openaisuggest'],
                });
            }
        });
    }
}
